import Vue                              from "vue";
import { mapGetters }                   from "vuex";
import { ErrorLogService, 
    NewsService }                       from "@/services/";
import { brandAndRegionAuthHelper }     from "@/components/mixins";
import { LoadingSpinner }               from "@/components";

export default Vue.extend({
    name: "NewsSideMenu",
    components: { LoadingSpinner },
    computed: {
        ...mapGetters(["getContentItem", "user", "activeAccountId", "brandAuth", "regionAuth"]),
    },
    mixins: [brandAndRegionAuthHelper],
    data: () => ({
        categories: [],
        departments: [],
        isLoading: true,
        active_li: 0
    }),
    mounted: function() {
        this.getCategories();
    },
    methods: {
        async getCategories() {
            let result;
            try {
                result = await NewsService.getNewsCategoryStoryCount(this.brandAuth, this.regionAuth);

                this.categories = result.filter(x => !x.IsDepartment);
                this.departments = result.filter((x) => x.IsDepartment);
            } catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.isLoading = false;
            }
        },
        getNewsCategoryStoryCount(categoryId : number) {
            this.setActiveCategory(categoryId);
            this.$emit("get-stories", categoryId);
        },
        setActiveCategory(id : number){
            this.active_li = id;
        }
    },
});
